import { useState } from 'react'
import { Play } from 'lucide-react'
import { PREDICATION_VIDEO_ID } from '@/data/media'

interface VideoThumbnailProps {
  thumbnail: string
  title: string
  videoId?: string
  className?: string
  playButtonClassName?: string
}

// Vignette cliquable qui se transforme en lecteur YouTube intégré — même logique que sur les
// cartes de prédication, extraite ici pour être réutilisée (ex. le mot du pasteur en vidéo).
export default function VideoThumbnail({
  thumbnail,
  title,
  videoId = PREDICATION_VIDEO_ID,
  className = '',
  playButtonClassName = 'w-14 h-14',
}: VideoThumbnailProps) {
  const [playing, setPlaying] = useState(false)

  if (playing) {
    return (
      <iframe
        className={className}
        src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    )
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      aria-label={`Lire : ${title}`}
      className={`group relative flex items-center justify-center overflow-hidden ${className}`}
    >
      <img src={thumbnail} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-cmp-navy/40 group-hover:bg-cmp-navy/30 transition-colors" />
      <span
        className={`relative rounded-full bg-white/15 ring-1 ring-white/30 backdrop-blur-sm group-hover:bg-white/25 transition-colors flex items-center justify-center ${playButtonClassName}`}
      >
        <Play size={22} fill="white" color="white" className="ml-0.5" />
      </span>
    </button>
  )
}
